import Reflux from "reflux";

import GetCategoriesAction from "../actions/GetCategoriesAction";
import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";
import RestrictionsStore from "./RestrictionsStore";
import categoryUtils from "../utils/categoryUtils";
import ArticleSearchClient from "../clients/ArticleSearchClient";
import TrackingUtil from "shared/src/utils/TrackingUtil";
import CategoryUtils from "../utils/categoryUtils";
import MainCategoryStore from "./MainCategoryStore";
import { ShoppingListCategories } from "../datatypes/ShoppingListCategories";
import { isEmpty } from "shared/src/utils/util";

let categoryLevel = 0;
const CategoryStore = Reflux.createStore({
    init() {
        this.listenTo(GetCategoriesAction, this.doSearch);
        this.listenTo(MainCategoryStore, this.configurationChanged);
        this.configurationChanged();
    },

    configurationChanged() {
        const categories = MainCategoryStore.getCategories();
        categoryLevel =
            categories && categories.categoriesSettings && categories.categoriesSettings.tabNavigation ? 1 : 0;
    },

    getCategoryLevel() {
        return categoryLevel;
    },

    doSearch(ids: Array<string>, listId: string) {
        if (ids && !isEmpty(ids)) {
            RestrictionsStore.doSearchWithRestriction(
                ids,
                (restrictionId) => this.doSearchWithRestriction(listId, restrictionId),
                (error) => {
                    TrackingUtil.trackUiErrorCa(
                        "CategoryPageStore",
                        "Fetching restricted article IDs in CategoryStore failed.",
                        error
                    );
                }
            );
        } else {
            const emptyAnswer = { listId: listId, success: null, error: null };
            this.trigger(emptyAnswer);
        }
    },

    doSearchWithRestriction(listId: string, restrictionId: string) {
        const storeId = SessionStore.getCustomerStore();
        if (!storeId) {
            return;
        }

        const requestQuery = {
            storeId,
            customerId: SessionStore.getCustomerId(),
            language: SessionStore.getLocale(),
            country: SessionStore.getCountry(),
            restriction: restrictionId,
            onlySearchable: false,
            preserveUnknownCategory: true,
            query: "*",
            rows: 0,
            page: 1
        };

        ArticleSearchClient.doSearch(requestQuery)
            .then((response) => {
                const transformed = {
                    listId: listId,
                    categories: CategoryUtils.categoryFromSearchResult(categoryLevel, response)
                };
                this.doSearchCompleted(transformed, listId);
            })
            .catch((e) => this.doSearchFailed(e, listId));
    },

    doSearchCompleted(response: ShoppingListCategories, listId: string) {
        const successAnswer = { listId: listId, success: response, error: null };
        this.trigger(successAnswer);
    },

    doSearchFailed(e: any, listId: string) {
        const failedAnswer = { listId: listId, error: categoryUtils.categoryError, success: null };
        TrackingUtil.trackUiErrorCa("CategoryStore", "get categories failed.", e);
        this.trigger(failedAnswer);
    }
});

export default CategoryStore;
